import { Object3D } from "three";
import { BatchedRenderer, QuarksUtil } from "three.quarks";
import { GameResourcesPackage } from "../../../../resources/GameResourcesPackage";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";

export class ExplosionAreaParticle extends Object3D {
    private particle: Object3D;

    public constructor(
        private readonly gameResources: GameResourcesPackage,
        private readonly batchRenderer: BatchedRenderer
    ) {
        super();
        this.particle = clone(this.gameResources.assets_game_particles_explosion_area_thjson);
        QuarksUtil.setAutoDestroy(this.particle, true);
        QuarksUtil.addToBatchRenderer(this.particle, this.batchRenderer);
        this.add(this.particle);
        QuarksUtil.play(this.particle);
    }
}
